module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Head-fmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-No-Indent-fmtx1"
  }, [_vm._v("I would like to thank my editor, Diana M. Pho, without whose suggestions this book would be much less interesting. Thanks are also due to my agent, Paul Lucas at Janklow & Nesbit Associates, who is an absolute rockstar.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Thank you to my incredibly helpful beta readers: Sheila Haab, Jill Bailin, Richard Bruce, and Becky Chambers. Around the time she was helping me out, Becky made her own debut with "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Long Way to a Small, Angry Planet")]), _vm._v(" and has since followed it up with "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A Closed and Common Orbit.")]), _vm._v(" They’re both great reads, so make sure to pick them up when you’re heading to the bookstore to buy a second copy of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Above all others, I must give credit to the people most responsible for making me who I am today: the baristas at Clocktower Coffee. Thank you. In the story of my life, you’re the real heroes.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Now, if I went on acknowledging everyone who made this book possible, it would seem that I only did a tiny fraction of the total work. This hews a little too close to the truth for my comfort, so I’m going to cut these acknowledgments short. But if you don’t see your name here, I’d like to thank you twice: once for your contribution, and again for your anonymity, through which you preserve the illusion that novel writing is a solitary affair.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2129ca1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 72
// module chunks = 0